import React from "react";
import { Redirect, Route, Switch, Link } from "react-router-dom";
import Index from "components/Index";
import Navbar from "components/Navbar";
import MyProfile from "components/my_profile/MyProfile";
import CompletedList from "components/completed_workshops/CompletedList";
import InProgressWorkShops from "components/InProgressWorkShops";
import WorkShopModules from "components/WorkShopModules";
import CreateOnlineWorkShop from "./create_workshop/CreateOnlineWorkShop";
import CreateWebinar from './create_webinar/CreateWebinar';
import CreatePublicWebinar from './creat_public_webinar/CreatePublicWebinar';
import CreatePublicWorksop from './create_public_workshop/CreatePublickWorkShop';
import CreateOrganizationWebinar from './create_organization_webinar/CreateOrganizationWebinar';
import CreateOrganizationWorkshop from './create_organization_workshop/CreateOrganizationWorkshop';
import { inject, observer } from "mobx-react";
import MyWorkshops from "./providers/MyWorkshops";
import OnlineWorkshopDetail from "./providers/online_workshop_details/OnlineWorkshopDetail";
import CreateCourseOnline from './create_course';
import classNames from "classnames";
import PrivacyPolicy from "components/informations/PrivacyPolicy";
import CookiesPolicy from "components/informations/CookiesPolicy";
import SubProcessors from "components/informations/SubProcessors";
import ProviderTerms from "components/informations/ProviderTerms";
import TermsOfCondition from "components/informations/TermsOfCondition";
import Purchased from "components/purchased/PurchasedList";
import SoldList from "components/sold/SoldList";
import Regular from "components/create_regular_workshop/Regular";
import RegularDetails from "components/regular_details/RegularDetails";
import TraineeList from "components/trainee_responces/TraineeList";
import InProgress from "components/in_progress/List";
import MyRegular from "components/providers/MyRegularWorkshops";
// import AboutUs from "components/informations/AboutUs";
import ContactUs from "components/informations/ContactUs";
import ProvidersList from "components/providers/ProvidersList";
import ProviderBio from "components/provider/ProviderBio";
import MyRegularWorkshopsAttendees from "components/myRegularWorkshop/MyRegularWS_Attendees";
import CreateProvider from "components/create_provider/CreateProvider";
import ModalOverlay from "./ModalOverlay";
import SponsorWorkshops from "./providers/SponsorWorkshops";
import ACIWorkshops from "./providers/ACIWorkshops";
import OnlineWorkshops from './providers/OnlineWorkshops';
import Webinars from './providers/Webinars';
import GroupSupervision from './providers/GroupSupervision';
import PublicWorkshops from './providers/PublicWorkshops';
import MyOnlineWorkshops from './providers/MyOnlineWorkshops';
import AdminProvidersList from './providersList/ProvidersList';
import MyOrgWorkshopsList from './providers/MyOrgWorkshops';
import MyOnlineWorkshopCert from './providers/MyOnlineWorkshopsCert';
import Reports from './reports';
import IacpUser from "./iacp_user/IacpUser";
import OrganizationsInfo from './OrganizationsInfo';
import OurServices from './informations/ourServices';
import AboutUs from './informations/aboutUs/index';
import CreateWorkshopInfo from './informations/createWorkshopInfo';
import IacpRoute from './IacpRoute';
import AciRoute from './AciRoute';

@inject("providerStore")
@inject("user")
@inject("alert")
@inject("preloader")
@observer
export default class Application extends React.Component {
  state = {
    cookieClientAgreed: false
  };

  componentDidMount() {
    const cookieAgreement = !!localStorage.getItem("cookieAgreement");
    if (cookieAgreement) {
      this.setState({
        cookieClientAgreed: true
      });
    }
  }

  cookieAgree = () => {
    localStorage.setItem("cookieAgreement", "true");
    this.setState({
      cookieClientAgreed: true
    });
  };

  isNavbarStatic = () => {
    const {pathname} = this.props.location;
    const {user} = this.props.user;
    return pathname === '/' || (user && pathname.includes('/details'));
  }

  render() {
    const staticNavbar = this.isNavbarStatic();
    return (
      <div className="wrapper">
        <div
          className={classNames("upload-conteiner", {
            nonDispayed: this.props.preloader.state
          })}
        >
          <div className="upload-workshop" />
          <div className="md-preloader">
            <svg version="1.1" height="75" width="75">
              <circle cx="37.5" cy="37.5" r="33.5" strokeWidth="8" />
            </svg>
          </div>
        </div>
        <Navbar isNavbarStatic={staticNavbar} />

        {!this.state.cookieClientAgreed && (
          <div className="cookies-policy">
            <div className="cookies-wrapper">
              <span>
                We use cookies to give you the best experience possible on our
                website, including analytics and content personalisation. By
                continuing to browse this website, you agree to the use of
                cookies.
                <Link to="/cookiespolicy" className="link-cookies">
                  Find out more
                </Link>
              </span>
              <button
                className="btn bordered card-btn"
                onClick={this.cookieAgree}
              >
                Accept
              </button>
            </div>
          </div>
        )}

        <Switch>
          <PrivateRouter path="/myprofile" component={MyProfile} />
          <PrivateRouter
            path="/createworkshop/:id?"
            component={CreateOnlineWorkShop}
          />
          <PrivateRouter
            path="/createwebinar/:id?"
            component={CreateWebinar}
          />
          <PrivateRouter
            path='/createpublicwebinar/:id?'
            component={CreatePublicWebinar}
          />
          <PrivateRouter
            path='/createpublicworkshop/:id?'
            component={CreatePublicWorksop}
          />
          <PrivateRouter
            path='/createorganization/:id?'
            component={CreateOrganizationWebinar}
          />
          <PrivateRouter
            path='/createorganizationworkshop/:id?'
            component={CreateOrganizationWorkshop}
          />
          <PrivateRouter path="/purchased" component={Purchased} />
          <PrivateRouter path="/provider/sold" component={SoldList} />
          <PrivateRouter path="/createregular/:id?" component={Regular} />

          <PrivateRouter
            path="/provider/my_reg_workshops"
            exact
            component={MyRegular}
          />
          <PrivateRouter
            path="/provider/my_org_workshops"
            exact
            component={MyOrgWorkshopsList}
          />
          <PrivateRouter
            path="/provider/my_reg_workshops/:id"
            component={MyRegularWorkshopsAttendees}
          />
          <PrivateRouter
            path="/provider/my_org_workshops/:id"
            component={MyRegularWorkshopsAttendees}
          />

          <PrivateRouter path="/inprogress_workshops" component={InProgress} />
          <PrivateRouter
            path="/provider/checkresponces/:id/:user_id"
            component={OnlineWorkshopDetail}
          />
          <PrivateRouter
            path="/provider/trainee_responses"
            component={TraineeList}
          />
          <PrivateRouter
            path="/providers"
            component={AdminProvidersList}
          />
          <PrivateRouter
            path="/reports"
            component={Reports}
            exact
          />
          <Route
            path='/our_services'
            component={OurServices}
          />
          <Route
            path='/create_course_online'
            component={CreateWorkshopInfo}
          />
          <Route
            path="/provider/my_workshop/:id"
            component={OnlineWorkshopDetail}
          />
          <Route
            path="/provider/my_webinar/:id"
            component={OnlineWorkshopDetail}
          />
          <Route
            path="/provider/org/:id"
            component={OnlineWorkshopDetail}
          />
          <Route
            path="/provider/my_group_supervision/:id"
            component={OnlineWorkshopDetail}
          />
          <Route
            path="/provider/my_public_webinars/:id"
            component={OnlineWorkshopDetail}
          />
          <Route
            path="/provider/my_public_workshops/:id"
            component={OnlineWorkshopDetail}
          />
          <Route
            path="/provider/cpd_cert_template"
            component={MyOnlineWorkshopCert}
          />
          <Route path="/provider_bios" exact component={ProvidersList} />
          <Route path="/provider/:id?" exact component={CreateProvider} />
          <Route path="/provider_bio/:id" exact component={ProviderBio} />


          <AciRoute path="/aci" exact component={ACIWorkshops} />
          <AciRoute path="/aci/details/:id" component={OnlineWorkshopDetail} />
          <AciRoute path="/aci/in_progress" component={InProgress} />
          <AciRoute path="/aci/purchased" component={Purchased} />
          <AciRoute path="/aci/completed" component={CompletedList} />


          <IacpRoute path="/iacp" exact component={SponsorWorkshops} />
          <IacpRoute path="/iacp/details/:id" component={OnlineWorkshopDetail} />
          <IacpRoute path="/iacp/in_progress" component={InProgress} />
          <IacpRoute path="/iacp/purchased" component={Purchased} />
          <IacpRoute path="/iacp/completed" component={CompletedList} />

          {/* <Route path="/aboutus" component={AboutUs} /> */}
          <Route path="/about-us" component={AboutUs} />
          <Route path="/contacts" component={ContactUs} />
          <Route path="/privacypolicy" component={PrivacyPolicy} />
          <Route path="/cookiespolicy" component={CookiesPolicy} />
          <Route path="/subprocessors" component={SubProcessors} />
          <Route path="/termsofconditions" component={TermsOfCondition} />
          <Route path="/providerterms" component={ProviderTerms} />
          <Route path="/details/online/:id" component={OnlineWorkshopDetail} />
          <Route path="/details/webinar/:id" component={OnlineWorkshopDetail} />
          <Route path="/details/group_supervision/:id" component={OnlineWorkshopDetail} />
          <Route path="/details/public_webinars/:id" component={OnlineWorkshopDetail} />
          <Route path="/details/public_workshops/:id" component={OnlineWorkshopDetail} />
          <Route path="/admin/details/:id" component={OnlineWorkshopDetail} />
          <Route path="/admin/regular/:id" component={RegularDetails} />
          <Route path="/details/regular/:id" component={RegularDetails} />
          <Route path="/provider/regular/:id" component={RegularDetails} />
          <Route path="/completed_workshops" component={CompletedList} />
          <Route path="/workshop_modules" component={WorkShopModules} />
          <Route path="/adminpanel/:type" component={MyWorkshops} />
          <Route path="/online" exact component={OnlineWorkshops} />
          <Route path="/webinars" exact component={Webinars} />
          <Route path="/group_supervision" exact component={GroupSupervision} />
          <Route path="/public_webinars" exact component={GroupSupervision} />
          <Route path="/public_workshops" exact component={PublicWorkshops} />
          <Route path="/provider_my_workshops" exact component={MyOnlineWorkshops} />
          <Route path="/provider_my_webinars" exact component={MyOnlineWorkshops} />
          <Route path="/provider_my_group_supervision" exact component={MyOnlineWorkshops} />
          <Route path="/provider_my_public_webinars" exact component={MyOnlineWorkshops} />
          <Route path="/provider_my_public_workshops" exact component={MyOnlineWorkshops} />
          <Route path="/organisations-info" exact component={OrganizationsInfo} />
          <Route path="/:type" component={MyWorkshops} />
          <PrivateRouter
            path="/inprogress_workshops"
            component={InProgressWorkShops}
          />
          <Route path="/" exact component={Index} />
        </Switch>

        <ModalOverlay />
      </div>
    );
  }
}

const PrivateRouter = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.token ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/newuser/signin",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);



// WEBPACK FOOTER //
// ./src/components/Application.jsx